module.exports = __webpack_public_path__ + "img/pic-01.4c6827fc.png";